import type { FieldDefinition } from '@/api/types'
import TableSettingsPanel from '@/components/TableSettingsPanel'
import {
  COLUMNS,
  PAGE_SIZES,
  customTableColumns,
  type ColumnId,
  type PageSize,
  type TableSettings,
} from '@/features/board/tableSettings'

/**
 * Deals table-view settings gear: page size, row height, zebra striping and columns.
 * Maps the deal {@link TableSettings} shape onto the shared {@link TableSettingsPanel}.
 */
export default function TableSettingsPopover({
  settings,
  onChange,
  fieldDefs,
}: {
  settings: TableSettings
  onChange: (next: TableSettings) => void
  /** Deal custom-field definitions, offered as additional columns. */
  fieldDefs: FieldDefinition[]
}) {
  const allColumns = [...COLUMNS, ...customTableColumns(fieldDefs)]
  return (
    <TableSettingsPanel<ColumnId>
      allColumns={allColumns}
      columns={settings.columns}
      onColumnsChange={(columns) => onChange({ ...settings, columns })}
      pageSizes={PAGE_SIZES}
      pageSize={settings.pageSize}
      onPageSizeChange={(pageSize) => onChange({ ...settings, pageSize: pageSize as PageSize })}
      rowHeight={settings.rowHeight}
      onRowHeightChange={(rowHeight) => onChange({ ...settings, rowHeight })}
      zebra={settings.zebra}
      onZebraChange={(zebra) => onChange({ ...settings, zebra })}
    />
  )
}
